<template>
  <div class="basic-block block-link-input">
    <div class=""
    <a
      :href="`/recommend/lp/${lpId}/basic/input`"
      class="block-link-input__link"
      @click.prevent="onBasicFortuneLickClick"
    >他の誕生日で占う</a>
  </div>
</template>

<script>
export default {
  name: 'BlockLinkInput',
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    onBasicFortuneLickClick(e){
      const param = {
        'event_category': `LP${this.lpId}basicresult-free-shindan-button`,
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      location.href = this.$handoverParams(e.target.href)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-link-input {
  background: #EDED67;
  padding: 0 0 40px;
  text-align: center;
  &__link {
    font-weight: bold;
    font-size: 16px;
    line-height: 12px;
    text-align: center;
    letter-spacing: 1px;
    text-decoration-line: underline;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/houen/blocks/BlockLinkInput.vue